import {
  Autocomplete,
  Backdrop,
  BackdropRoot,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  ThemeProvider,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
// import AccessLevel from "./AccessLevel";
import { createTheme } from "@mui/material/styles";

import { common_axios } from "../../../../App";
import { toast } from "react-toastify";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Loader from "../../../../components/Loader";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import DeleteIcon from "@mui/icons-material/Delete";
import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import axios from "axios";
import { dateFormatter } from "../../../../helper/helper";
export default function DefineRoute() {
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
  });

  const [open, setOpen] = useState(false);
  const [data1, setData1] = useState([]);
  const [data, setData] = useState([]);
  const [senderType, setSenderType] = useState(null);

  // async function FilterGet() {
  //   try {
  //          setOpen(true);
  //     const result = await common_axios(
  //       "${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin-master/v1/senderids?type=Promotional"
  //     );

  //     if (result.data.statusDescription.statusCode == 200) {

  //       setData(result.data.listSenderId);
  //     } else {
  //                  // setTableLoader(false);
  //       setOpen(false);
  //       toast.error(result.data.statusDescription.statusMessage,{
  //           theme: "colored",
  //         });
  //       // console.log(res.data.statusMessage);
  //     }
  //   } catch (error) {
  //           setOpen(false);
  //     console.log(error);
  //     toast.error("Please Check Your Network",{
  //           theme: "colored",
  //         });
  //   }
  // }

  const userId = localStorage.getItem("USerId");

  const validationSchema = yup.object({
    smscName: yup.object().required("smscName is required!"),
    category: yup.string().required("category is required!"),
    type: yup.string().required("type is required!"),
    throughPut: yup.string().required("throughPut is required!"),
    routeName: yup
      .string("Enter your Route Name")
      .required("routeName is required")
      .min(3, "Route Name should be of minimum 3 characters length")
      .max(30, "Route Name should be of maximum 30 characters length"),
    // .required("dltId is required"),
  });

  const formik = useFormik({
    initialValues: {
      type: "",
      category: "",
      smscName: null,
      throughPut: "",
      routeName: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validateOnChange: true,

    validationSchema: validationSchema,

    onSubmit: async (values) => {
      try {
        setOpen(true);
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/route/create`,
          {
            userId: localStorage.getItem("UserId"),
            createdBy: localStorage.getItem("Username"),
            routeName: values.routeName,
            type: values.type,
            smscName: values.smscName.smscName,
            category: values.category,
            throughput: values.throughPut,
            isDefault: true,
            status: true,
            smscId: values.smscName.id,
          }
        );

        if (res.data.statusDescription.statusCode == 200) {
          formik.handleReset();
          res.data.routesModel.creationDate = await String(
            new Date(res.data.routesModel.creationDate)
          );
          setSenderType(null);
          await setData([...data, res.data.routesModel]);
          setOpen(false);

          await toast.success("Created Successfully", {
            theme: "colored",
          });
        } else {
          setOpen(false);

          await toast.error(res.data.statusDescription.statusMessage, {
            theme: "colored",
          });
        }
      } catch (error) {
        console.log(error);
        setOpen(false);

        await toast.error("Something went wrong", {
          theme: "colored",
        });
      }
    },
  });

  const columns = useMemo(
    () => [
      {
        Header: "Route Name",

        accessor: "routeName", // accessor is the "key" in the data
      },
      {
        Header: "SMSC Name",

        accessor: "smscName", // accessor is the "key" in the data
      },
      {
        Header: "ThroughPut",

        accessor: "throughput", // accessor is the "key" in the data
      },
      {
        Header: "Type",

        accessor: "type",
      },
      {
        Header: "Category",

        accessor: "category",
      },

      {
        Header: "Status",

        accessor: "approved",
        Cell: (cell) => {
          return (
            <>
              {!cell.row.original.status ? (
                <div className="badge badge_8 bg-warning">Disabled</div>
              ) : (
                <div className="badge badge_8 bg-success">Enabled</div>
              )}
            </>
          );
        },
      },
      {
        Header: "Date",

        accessor: "createdAt", // accessor is the "key" in the data
        Cell: (cell) => {
          return <>{dateFormatter(cell.row.original.createdAt)}</>;
        },
      },
    ],
    []
  );
  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    console.log({ selectedFlatRows });
  };

  const fetchUser = async () => {
    try {
      setOpen(true);
      const res = await common_axios(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/smscs`
      );

      if (res.data.statusDescription.statusCode == 200) {
        setData1(res.data.listOfSmscs);

        setOpen(false);
      } else {
        setOpen(false);
        toast.error(res.data.statusDescription.statusMessage, {
          theme: "colored",
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await toast.error("Something went wrong", {
        theme: "colored",
      });
    }
  };

  useEffect(async () => {
    fetchUser();
  }, []);

  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <ThemeProvider theme={theme}>
          <div className="container-fluid">
            <div className="card">
              <div className="card-header p-3 pt-2">
                <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 p_static position-absolute">
                  <i className="material-icons opacity-10">person</i>
                </div>
                <div className="pt-1">
                  <p
                    className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline"
                    style={{ marginLeft: "70px" }}
                  >
                    Define Route
                  </p>
                  <p className="text-sm mb-0  text-capitalize d-inline-block float-end">
                    Field(s) marked with{" "}
                    <span className="text-danger fw-bold">*</span> are
                    mandatory.
                  </p>
                </div>
              </div>
              <div className="card-body">
                <div className="card shadow-none border bg_blue">
                  <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                    Details
                  </span>

                  <div className="card-body text-lg-start text-center">
                    <form
                      onSubmit={formik.handleSubmit}
                      className="row g-3 needs-validation"
                      novalidate
                    >
                      <div className="col-md-3">
                        <TextField
                          required
                          className="w-100"
                          label="Route name"
                          name="routeName"
                          variant="outlined"
                          size="small"
                          type="text"
                          onInput={(e) => {
                            e.target.value = e.target.value
                              .toString()
                              .slice(0, 20);
                          }}
                          value={formik.values.routeName}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.routeName &&
                            Boolean(formik.errors.routeName)
                          }
                          helperText={
                            formik.touched.routeName && formik.errors.routeName
                          }
                        />
                      </div>

                      <div className="col-md-3">
                        <FormControl required fullWidth>
                          <InputLabel size="small" id="test-select-label">
                            Select category
                          </InputLabel>
                          <Select
                            size="small"
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={formik.values.category}
                            label="Select category"
                            onChange={(e) => {
                              formik.setFieldValue("category", e.target.value);
                              setSenderType(e.target.value);
                            }}
                          >
                            {[
                              { id: 0, name: null, value: null },
                              {
                                id: 1,
                                name: "Promotional",
                                value: "Promotional",
                              },
                              {
                                id: 2,
                                name: "Transactional",
                                value: "Transactional",
                              },
                              {
                                id: 3,
                                name: "OTP",
                                value: "OTP",
                              },
                            ].map((d) => {
                              return (
                                <MenuItem value={d.value}> {d.name}</MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </div>

                      <div className="col-md-3">
                        <Autocomplete
                          fullWidth
                          required
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          getOptionLabel={(option) => `${option.smscName}`}
                          options={data1}
                          value={formik.values.smscName}
                          onChange={(e, val) => {
                            console.log({ val });
                            formik.setFieldValue("smscName", val);
                            formik.setFieldValue("type", val.type);
                            formik.setFieldValue("throughPut", val.throughput);
                          }}
                          renderInput={(params) => (
                            <TextField
                              required
                              {...params}
                              size="small"
                              label="SMSC name"
                            />
                          )}
                        />
                      </div>

                      {!formik.errors?.routeName &&
                        formik.values?.routeName &&
                        !formik.errors?.category &&
                        formik.values?.smscName && (
                          <>
                            <div className="col-md-3">
                              {/* <FormControl disabled fullWidth>
                          <InputLabel size="small" id="test-select-label">
                            Select Type
                          </InputLabel>
                          <Select
                            size="small"
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={formik.values.type}
                            label="Select Type"
                            onChange={(e) => {
                              formik.setFieldValue("type", e.target.value);
                              setSenderType(e.target.value);
                            }}
                          >
                            {[
                              { id: 0, name: null, value: null },
                              {
                                id: 1,
                                name: "TR",
                                value: "TR",
                              },
                              {
                                id: 2,
                                name: "RX",
                                value: "RX",
                              },
                              {
                                id: 3,
                                name: "TRX",
                                value: "TRX",
                              },
                            ].map((d) => {
                              return (
                                <MenuItem value={d.value}> {d.name}</MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl> */}
                              <TextField
                                className="w-100"
                                label="Type"
                                disabled
                                name="type"
                                variant="outlined"
                                size="small"
                                type="text"
                                value={formik.values.type}
                                onChange={formik.handleChange}
                                error={
                                  formik.touched.type &&
                                  Boolean(formik.errors.type)
                                }
                                helperText={
                                  formik.touched.type && formik.errors.type
                                }
                              />
                            </div>

                            <div className="col-md-3">
                              <TextField
                                className="w-100"
                                label="Through Put"
                                disabled
                                name="throughPut"
                                variant="outlined"
                                size="small"
                                type="number"
                                onInput={(e) => {
                                  e.target.value = Math.max(
                                    0,
                                    parseInt(e.target.value)
                                  )
                                    .toString()
                                    .slice(0, 4);
                                }}
                                value={formik.values.throughPut}
                                onChange={formik.handleChange}
                                error={
                                  formik.touched.throughPut &&
                                  Boolean(formik.errors.throughPut)
                                }
                                helperText={
                                  formik.touched.throughPut &&
                                  formik.errors.throughPut
                                }
                              />
                            </div>
                          </>
                        )}

                      <div className="text-end">
                        <button
                          type="submit"
                          className="btn bg-gradient-primary m-0"
                        >
                          Submit
                          <i className="material-icons opacity-10">
                            arrow_right_alt
                          </i>
                        </button>

                        <button
                          style={{ marginLeft: "6px" }}
                          type="button"
                          onClick={formik.handleReset}
                          className="btn bg-gradient-secondary m-0 ms-2"
                        >
                          Reset
                          <i className="material-icons opacity-10">
                            settings_backup_restore
                          </i>
                        </button>
                      </div>

                      {/* <div className="row">
                            <div className="col-md-3 mt-3">
                              <button className="btn btn-primary" type="submit">
                                Submit
                              </button>
                              <button
                                type="button"
                                onClick={formik.handleReset}
                                className="btn btn-secondary"
                              >
                                Reset
                              </button>
                            </div>
                          </div> */}
                    </form>
                  </div>
                </div>
              </div>

              {data.length > 0 && (
                <div className="card-body">
                  <div className="container-fluid p-0">
                    <div className="card shadow-none border bg_blue mt-5">
                      <span className="badge rounded-pill bg-primary mt-n3 ms-5 ">
                        Recently Added
                      </span>
                      <div className="p-4">
                        <div className="d-flex justify-content-between my-3">
                          <select
                            value={pageSize}
                            className="dropdown"
                            onChange={(e) => {
                              setPageSize(Number(e.target.value));
                            }}
                          >
                            {[10, 25, 50].map((value, i) => {
                              return (
                                <option
                                  className="dropdown-menu"
                                  aria-labelledby="dropdownMenuButton1"
                                  value={value}
                                  key={value}
                                >
                                  {" "}
                                  Show {value}
                                </option>
                              );
                            })}
                          </select>

                          <div></div>
                          <div className="d-flex align-items-center">
                            <TextField
                              className="ms-4"
                              style={{
                                borderRadius: "4px",
                              }}
                              type="text"
                              label="Search"
                              name="Search"
                              variant="outlined"
                              // value={number}
                              size="small"
                              value={globalSearchValue || ""}
                              onChange={(e) => {
                                onChange(e.target.value);
                                setGlobalSearchValue(e.target.value);
                              }}
                            />
                          </div>
                        </div>

                        <div>
                          {selectedFlatRows.length > 0 && (
                            <button onClick={deletUser}>Delete Users</button>
                          )}
                        </div>

                        <table
                          {...getTableProps()}
                          id="example"
                          className="table table-striped table-bordered dataTable table-sm"
                          style={{ width: "100%" }}
                        >
                          <thead>
                            {headerGroups.map((headerGroup) => (
                              <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                  <th
                                    {...column.getHeaderProps(
                                      column.getSortByToggleProps()
                                    )}
                                    className="text-center width_2"
                                  >
                                    {column.render("Header")}
                                    <span>
                                      {column.isSorted
                                        ? column.isSortedDesc
                                          ? "↑"
                                          : "↓"
                                        : ""}
                                    </span>
                                  </th>
                                ))}
                              </tr>
                            ))}
                          </thead>
                          <tbody {...getTableBodyProps()}>
                            {page.map((row) => {
                              prepareRow(row);
                              return (
                                <tr {...row.getRowProps()}>
                                  {row.cells.map((cell) => {
                                    return (
                                      <td
                                        {...cell.getCellProps()}
                                        className="text-center"
                                      >
                                        {cell.render("Cell")}
                                      </td>
                                    );
                                  })}
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>

                        <div className="d-flex justify-content-between">
                          <div>
                            <span>
                              Page:
                              <strong>
                                {pageIndex + 1} of {pageOptions.length}
                              </strong>
                            </span>
                          </div>

                          {/* <div>
                            <span>
                              Go to Page :{""}
                              <input
                                type="number"
                                // defaultValue={pageIndex + 1}
                                value={pageIndex + 1}
                                onChange={(e) => {
                                  const pageNumber = e.target.value
                                    ? Number(e.target.value) - 1
                                    : 0;
                                  gotoPage(pageNumber);
                                }}
                                style={{ width: "50px" }}
                              />
                            </span>
                          </div> */}

                          <div>
                            <button
                              className="btn btn_secondary m-0"
                              type="button"
                              disabled={!canPreviousPage}
                              style={{ background: "#2C97D4" }}
                              onClick={() => {
                                previousPage();
                              }}
                            >
                              Prev
                            </button>

                            <button
                              className="btn btn_secondary m-0"
                              type="button"
                              disabled={!canNextPage}
                              style={{ background: "#2C97D4" }}
                              onClick={() => {
                                nextPage();
                              }}
                            >
                              Next
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="text-end me-3 mb-3">
                <p>View Routes</p>
                <Link
                  to="/dashboard/ViewRoute"
                  style={{ color: "#63B7E6", marginLeft: "30px" }}
                >
                  <span>Click here !!!</span>
                </Link>
              </div>
            </div>
          </div>
        </ThemeProvider>
      </main>
    </>
  );
}
